import type {z} from "zod";

export const ADDRESS_STREET_REGEX = /\d|(^|[\s,])[a-z]{1,2}([\s,]|$)/i;

// Many UK streets have no house numbers (named houses, or no number at all)
const COUNTRIES_WITHOUT_STREET_NUMBERS = ["United Kingdom"];

export const isStreetNumberRequired = (country?: string | null) =>
  !country || !COUNTRIES_WITHOUT_STREET_NUMBERS.includes(country);

// Object-level so the check can read the country; it runs whenever the street itself is a string, so the error
// still shows while other fields are invalid
export const withStreetNumberCheck = <T extends z.ZodObject>({
  countryKey,
  schema,
  streetKey,
}: {
  countryKey: keyof z.output<T> & string;
  schema: T;
  streetKey: keyof z.output<T> & string;
}) =>
  schema.refine(
    data => {
      const street = data[streetKey] as string;

      return !street || !isStreetNumberRequired(data[countryKey] as string | null) || ADDRESS_STREET_REGEX.test(street);
    },
    {
      message: "company_profile:missing_address_street_number_error",
      path: [streetKey],
      when: ({value}) => typeof (value as Record<string, unknown> | null)?.[streetKey] === "string",
    },
  );
